import createReducer from 'reducers/createReducer';

import { ShopManagerInfo } from 'actions/actionTypes';

const INITIAL_STATE = {
    list: [],
    data: {
        shopManagerIdx: '',
        id: '',
        name: '',
        shopManagerTypeCode: '',
        password: ''
    },
    error: {
        triggered: false,
        message: ''
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [ShopManagerInfo.CHANGE_SHOP_MANAGER_INFO]: (state, action) => {
        state.data[action.payload.element] = action.payload.value;  // element를 사용하여 값 업데이트
    },

    [ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;  // 초기 상태로 에러 리셋
    },
    [ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST_SUCCESS]: (state, action) => {
        const { shopManagerIdx, id, name, shopManagerTypeCode } = action.payload.responseData;  // 중첩된 구조 해제

        state.data = {
            ...state.data,  // 기존 데이터 유지
            shopManagerIdx,
            id,
            name,
            shopManagerTypeCode  // API 응답 데이터 업데이트
        };
    },
    [ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    },

    //Redux 리듀서에서 EDIT_SHOP_MANAGER_INFO_REQUEST 액션과 그 성공 및 실패 케이스를 처리하는 부분입니다. 
    //여기에 액션으로부터 비밀번호를 전달하고 실패 시 적절히 처리되도록 하려면 일부 수정을 할 수 있습니다.
    [ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;  // 초기 상태로 에러 리셋
        // 필요 시 비밀번호나 다른 데이터를 상태에 저장할 수 있음
        state.loading = true;  // 로딩 상태 추가 (선택적)
    },

    [ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST_SUCCESS]: (state, action) => {
        // 성공 시 필요한 상태 업데이트 추가
        state.loading = false; // 로딩 상태 해제 (선택적)
        // 성공적으로 저장된 매니저 정보나 다른 관련 정보를 업데이트
        // state.shopManagerInfo = action.payload;  // 예시
    },

    [ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST_FAILURE]: (state, action) => {
        state.loading = false;  // 실패 시 로딩 상태 해제
        state.error = {
            triggered: true,
            message: action.payload,  // 실패 시 메시지 업데이트
        };
    },

});

export default reducer;
